export enum PromoType {
  Promocode = 'Промокод',
}

export enum DeliveryType {
  Delivery = 'Доставка',
  Pickup = 'Самовывоз',
  None = 'Доставка не указана',
}

export enum PaymentType {
  Sbrf = 'Онлайн',
  CardDelivery = 'Водителю - Картой',
  CashDelivery = 'Водителю - Наличными',
  CashCardShop = 'В магазине',
  Sbp = 'Система быстрых платежей',
  None = 'Оплата не указана',
}

export interface OrderEntryGoogleAnalytic {
  id: string;
  price: number;
  quantity: number;
}
export interface OrderEntryGoogleAnalyticV4 {
  item_id: string;
  item_name: string;
  price: number;
  quantity: number;
}
